import { Link } from "gatsby";
import React, { useState } from "react";

const activeStyle = {
	color: "var(--primary-dark)",
	fontWeight: 600,
};

const Navbar = () => {
	const [isExpanded, toggleExpansion] = useState(false);
	const linkClasses = "nav-link";
	const clickLink = () => toggleExpansion(false);

	return (
		<nav
			className="mobile-nav"
			style={{ position: "sticky", top: 0, zIndex: 50, background: "var(--surface)", borderBottom: "1px solid var(--border)" }}
		>
			<div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", padding: "12px 24px" }}>
				<button
					style={{
						border: "1px solid var(--border)",
						display: "flex",
						alignItems: "center",
						padding: "8px 12px",
						borderRadius: 6,
						color: "var(--primary-dark)",
						background: "transparent",
					}}
					onClick={() => toggleExpansion(!isExpanded)}
					type="button"
				>
					<svg style={{ fill: "currentColor", height: 12, width: 12 }} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
						<title>Menu</title>
						<path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
					</svg>
					<span style={{ marginLeft: 16 }}>Menu</span>
				</button>
				<div style={{ display: isExpanded ? "block" : "none", width: "100%", marginTop: 12 }}>
					<Link to="/" className={linkClasses} onClick={clickLink} activeStyle={activeStyle} style={{ display: "block", padding: "10px 0" }}>
						Home
					</Link>
					<Link to="/our-team" className={linkClasses} onClick={clickLink} activeStyle={activeStyle} style={{ display: "block", padding: "10px 0" }}>
						Our Team
					</Link>
					<Link to="/services" className={linkClasses} onClick={clickLink} activeStyle={activeStyle} style={{ display: "block", padding: "10px 0" }}>
						Services
					</Link>
					<Link to="/patient-information" className={linkClasses} onClick={clickLink} activeStyle={activeStyle} style={{ display: "block", padding: "10px 0" }}>
						Patient Information
					</Link>
					<Link to="/articles" className={linkClasses} onClick={clickLink} activeStyle={activeStyle} style={{ display: "block", padding: "10px 0" }}>
						Articles
					</Link>
					<Link to="/Newsletters" className={linkClasses} onClick={clickLink} activeStyle={activeStyle} style={{ display: "block", padding: "10px 0" }}>
						Newsletters
					</Link>
					<Link to="/contact" className={linkClasses} onClick={clickLink} activeStyle={activeStyle} style={{ display: "block", padding: "10px 0" }}>
						Contact
					</Link>
				</div>
			</div>
		</nav>
	);
};

export default Navbar;
